var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options,"triggerChange":_vm.triggerChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }